import styled from 'styled-components';
const getHorizontalAttributes = (horizontal) => {
    if (horizontal === 'center')
        return '';
    if (horizontal === 'right')
        return 'left: 100%';
    if (horizontal === 'left')
        return 'right: 100%';
    return '';
};
const getVerticalAttributes = (vertical) => {
    if (vertical === 'center')
        return 'bottom: -185px';
    if (vertical === 'bottom')
        return 'top: calc(100% + 20px);';
    if (vertical === 'top')
        return 'bottom: calc(100% + 20px);';
    return '';
};
export const CalendarArrowFillerStyled = styled.div `
  height: 19px;
  width: auto;
`;
export const CalendarButtonsContainerStyled = styled.div `
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;
  align-items: center;
`;
export const CalendarContainerStyled = styled.div `
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 29px 28px;
  width: 282px;
  min-height: 311px;
  flex-shrink: 0;
  border-radius: 9px;
  background: ${({ theme }) => theme.colors.gray100};
  box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #fff,
    2px 2px 4px 0px rgba(114, 142, 171, 0.1);
  position: relative;
  @media (max-width: 350px) {
    padding: 18px 14px;
    width: 206px;
    height: 331px;
  }
  ${({ desktopMode, anchorOrigin }) => {
    const { vertical, horizontal } = anchorOrigin;
    if (desktopMode)
        return `
      border-radius: 4px;
      position: absolute;
      z-index: 1000;
      top: calc(100% + 20px);
      width: max(min-content, 100%);
      box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #FFF, 2px 2px 4px 0px rgba(114, 142, 171, 0.10);
      button:nth-child(1) {
        border-radius: 4px 4px 0px 0px;
      }
      ${getHorizontalAttributes(horizontal)};
      ${getVerticalAttributes(vertical)};
      `;
    return '';
}};
`;
export const CalendarContentStyled = styled.div `
  align-items: center;
  align-content: flex-start;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
export const CalendarContentWrapperStyled = styled.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const CalendarHeaderStyled = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 19px;
  flex-shrink: 0;
`;
export const CalendarHeaderCenterStyled = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 19px;
  gap: 10px;
  flex-shrink: 0;
`;
export const CalendarLabelsStyled = styled.div `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  flex-shrink: 0;
`;
//# sourceMappingURL=styled.js.map